<template>
  <div :class="classes">
      <wt-table :labels="tableLabels" :list="tableData" >
          <slot/>
      </wt-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-banner-table'

export default {
  name: 'pt-banner-table',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
